import { Component} from '@angular/core';
import { OwlOptions } from 'ngx-owl-carousel-o';

import emailjs, { type EmailJSResponseStatus } from '@emailjs/browser';
export interface Service {
  icon: string;
  title: string;
  desc: string;
}

export interface Pricing {
  icon: string;
  name: string;
  price: string;
  features: { value: string; text: string; available: boolean }[];
}

@Component({
  standalone: false,
  selector: 'app-services',
  templateUrl: './services.component.html',
  styleUrl: './services.component.css'
})
export class ServicesComponent {
  //Services
  services: Service[] = [
    {
      icon: 'bi-laptop purple-color',
      title: 'Responsive',
      desc:'Integer purus ipsum, auctor vitae posuere et, consectetur ac leo. Pellentesque sit amet risus sagittis, fermentum ligula.',
    },
    {
      icon: 'bi-exclude color-primary',
      title: 'Development',
      desc:'Integer purus ipsum, auctor vitae posuere et, consectetur ac leo. Pellentesque sit amet risus sagittis, fermentum ligula.',
    },
    {
      icon: 'bi-gear blue-color',
      title: 'Implementation',
      desc:'Integer purus ipsum, auctor vitae posuere et, consectetur ac leo. Pellentesque sit amet risus sagittis, fermentum ligula.',
    },
    {
      icon: 'bi-chat-dots-fill green-color',
      title: 'Live Support',
      desc:'Integer purus ipsum, auctor vitae posuere et, consectetur ac leo. Pellentesque sit amet risus sagittis, fermentum ligula.',
    },
    {
      icon: 'bi-layers-fill yellow-color',
      title: 'Pixel Perfect',
      desc:'Integer purus ipsum, auctor vitae posuere et, consectetur ac leo. Pellentesque sit amet risus sagittis, fermentum ligula.',
    },
    {
      icon: 'bi-trophy-fill brown-color',
      title: 'Award Winning',
      desc:'Integer purus ipsum, auctor vitae posuere et, consectetur ac leo. Pellentesque sit amet risus sagittis, fermentum ligula.',
    }
  ];

  //Footer
  socialLinks = [
    { icon: 'bi-facebook', url: '/' },
    { icon: 'bi-twitter-x', url: '/' },
    { icon: 'bi-pinterest', url: '/' },
    { icon: 'bi-dribbble', url: '/' }
  ];

  quickLinks = [
    { name: 'About Us', url: '/about-us' },
    { name: 'Services', url: '/services' },
    { name: 'Portfolio', url: '/portfolio-one' },
    { name: 'Blogs', url: '/blog-grid' },
    { name: 'Contact Us', url: '/contact' }
  ];

  recentPosts = [
    {
      image: 'assets/images/blogs/post-img-sm.jpg',
      title: 'Ut venenatis, Commodo ligula',
      desc: 'Lorem ipsum dolor sit amet, adipiscing elit...'
    },
    {
      image: 'assets/images/blogs/post-img-sm-2.jpg',
      title: 'Ut venenatis, Commodo ligula',
      desc: 'Lorem ipsum dolor sit amet, adipiscing elit...'
    }
  ];

  // OWl Slider
  testimonialOptions: OwlOptions = {
  loop: true,
  dots: true,
  margin:30,
  nav:false,
  autoplay:true,
  autoplaySpeed: 2000,
  navSpeed: 2000,
  items: 3,
  navText: ['<i class="bi bi-arrow-left"></i>', '<i class="bi bi-arrow-right"></i>'],
  }

  testimonials = [
    {
      name: "Melina Walber",
      position: "manager@Chaos.io",
      image: "avatar-4.jpg",
      desc:"Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus."
    },

    {
      name: "Doris Campos",
      position: "founder@Chaos.io",
      image: "avatar-5.jpg",
      desc:"Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus."
    },

    {
      name: "Melina Walber",
      position: "manager@Chaos.io",
      image: "avatar-6.jpg",
      desc:"Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus."
    },

    {
      name: "Doris Campos",
      position: "founder@Chaos.io",
      image: "avatar-1.jpg",
      desc:"Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus."
    }
  ];

  //Pricing Tables
  pricingPlans: Pricing[] = [
    {
      icon: 'bi bi-rocket-takeoff',
      name: 'Basic',
      price: '$195.99',
      features: [
        { value: '15', text: 'Email Account', available: true },
        { value: '100GB', text: 'Space', available: true },
        { value: '1', text: 'Domain Name', available: true },
        { value: '500GB', text: 'Bandwidth', available: true },
        { value: '25', text: 'MySQL Databases', available: true },
        { value: 'Unlimited', text: 'Subdomains', available: false }
      ]
    },
    {
      icon: 'bi bi-diamond-half',
      name: 'Standard',
      price: '$195.99',
      features: [
        { value: '15', text: 'Email Account', available: true },
        { value: '100GB', text: 'Space', available: true },
        { value: '1', text: 'Domain Name', available: true },
        { value: '500GB', text: 'Bandwidth', available: true },
        { value: '25', text: 'MySQL Databases', available: true },
        { value: 'Unlimited', text: 'Subdomains', available: false }
      ]
    },
    {
      icon: 'bi bi-pie-chart-fill',
      name: 'Ultimate',
      price: '$195.99',
      features: [
        { value: '15', text: 'Email Account', available: true },
        { value: '100GB', text: 'Space', available: true },
        { value: '1', text: 'Domain Name', available: true },
        { value: '500GB', text: 'Bandwidth', available: true },
        { value: '25', text: 'MySQL Databases', available: true },
        { value: 'Unlimited', text: 'Subdomains', available: false }
      ]
    }
  ];
}
